module.exports = __webpack_public_path__ + "img/DK87334716.b46b607f.png";